import React from "react";
import { Helmet } from "react-helmet";

const DEFAULT_IMAGE = "https://shift-it.io/OGPreview-092025.png";

/**
 * SEO component for consistent meta tags across pages.
 *
 * Props:
 *   title       - Page title (required)
 *   description - Meta description (required)
 *   canonical   - Canonical URL (required)
 *   image       - OG/Twitter image URL (defaults to DEFAULT_IMAGE)
 *   imageWidth  - OG image width (default 1200)
 *   imageHeight - OG image height (default 630)
 *   jsonLd      - Optional JSON-LD object (e.g. Organization schema)
 */
export default function SEO({
  title,
  description,
  canonical,
  image = DEFAULT_IMAGE,
  imageWidth = 1200,
  imageHeight = 630,
  jsonLd,
}) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content={String(imageWidth)} />
      <meta property="og:image:height" content={String(imageHeight)} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Optional JSON-LD */}
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
